export const permissionsCodes = {
  viewCompanyProfile: "canAccessCompanyProfilePage",
  editCompanyData: "canEditCompanyData",
  viewUsersPage: "u1",
  addEditUsers: "u2",
  addRemoveUsers: "u3",
  impersonate: "canImpersonate",
  manageUserGroups: "g1",
  viewPositionsPage: "p1",
  addEditPositions: "p2",
  viewLocations: "l1",
  addEditLocations: "l2",
  addRemoveLocations: "l3",
  locationGroups: "g2",
  viewGLAccounts: "gL1",
  addEditGLAccounts: "gL2",
  glAccountGroups: "g3",
  viewForms: "canAccessIncidentFormsPage",
  addForms: "canAddNewForms",
  submitForms: "canSubmitForms",
  viewSubmittedReports: "canViewSubmittedReports",
  viewAuditPage: "canViewAuditPage",
  viewITPage: "r1",
  viewMaintenancePage: "r2",
  viewSurveys: "r3",
  viewOthers: "r4",
  viewAssets: "a1",
  addAssets: "a2",
  viewAllAssets: "a3",
  viewVendors: "v1",
  addVendors: "v2",
};

export const permissionsList = [
  {
    category: "Company Profile",
    PermissionCategoryID: 1,
    permissions: [
      {
        name: permissionsCodes.viewCompanyProfile,
        permissionName: "View Company Profile Page",
      },
      {
        name: permissionsCodes.editCompanyData,
        permissionName: "Edit Company Data",
      },
    ],
  },
  {
    category: "Users",
    PermissionCategoryID: 2,
    permissions: [
      {
        name: permissionsCodes.viewUsersPage,
        permissionName: "View Users Page",
      },
      {
        name: permissionsCodes.addEditUsers,
        permissionName: "Edit Users",
      },
      {
        name: permissionsCodes.addRemoveUsers,
        permissionName: "Add and Remove Users",
      },
      {
        name: permissionsCodes.impersonate,
        permissionName: "Can Impersonate",
      },
      {
        name: permissionsCodes.manageUserGroups,
        permissionName: "Mange User Groups",
      },
    ],
  },
  {
    category: "Positions",
    PermissionCategoryID: 3,
    permissions: [
      {
        name: permissionsCodes.viewPositionsPage,
        permissionName: "View Positions Page",
      },
      {
        name: permissionsCodes.addEditPositions,
        permissionName: "Add/Edit Positions",
      },
    ],
  },
  {
    category: "Locations",
    PermissionCategoryID: 4,
    permissions: [
      {
        name: permissionsCodes.viewLocations,
        permissionName: "View Location Page",
      },
      {
        name: permissionsCodes.addEditLocations,
        permissionName: "Edit Locations",
      },
      {
        name: permissionsCodes.addRemoveLocations,
        permissionName: "Add and Remove Locations",
      },
      {
        name: permissionsCodes.locationGroups,
        permissionName: "Manage Location Groups",
      },
    ],
  },
  {
    category: "GL Accounts",
    PermissionCategoryID: 4,
    permissions: [
      {
        name: permissionsCodes.viewGLAccounts,
        permissionName: "View GL Accounts Page",
      },
      {
        name: permissionsCodes.addEditGLAccounts,
        permissionName: "Add/Edit GL Accounts",
      },
      {
        name: permissionsCodes.glAccountGroups, //just "g" for groups
        permissionName: "Mange GL Account Groups",
      },
    ],
  },
  {
    category: "Reporting",
    PermissionCategoryID: 5,
    permissions: [
      {
        name: permissionsCodes.viewForms,
        permissionName: "View and Schedule Forms",
      },
      {
        name: permissionsCodes.addForms,
        permissionName: "Add Forms",
      },
      {
        name: permissionsCodes.submitForms,
        permissionName: "Submit Forms",
      },
      {
        name: permissionsCodes.viewSubmittedReports,
        permissionName: "View Incident Reports",
      },
      {
        name: permissionsCodes.viewAuditPage,
        permissionName: "View Audit Reports",
      },
      {
        name: permissionsCodes.viewITPage,
        permissionName: "View I.T Ticketing",
      },
      {
        name: permissionsCodes.viewMaintenancePage,
        permissionName: "View Maintenance Management",
      },
      {
        name: permissionsCodes.viewSurveys,
        permissionName: "View Surveys",
      },
      {
        name: permissionsCodes.viewOthers,
        permissionName: "View Other",
      },
    ],
  },
  {
    category: "Assets",
    PermissionCategoryID: 7,
    permissions: [
      {
        name: permissionsCodes.viewAssets,
        permissionName: "View Assets Page",
      },
      {
        name: permissionsCodes.addAssets,
        permissionName: "Add/Edit Assets",
      },
      {
        name: permissionsCodes.viewAllAssets,
        permissionName: "View All Assets",
      },
    ],
  },
  {
    category: "Vendors",
    PermissionCategoryID: 6,
    permissions: [
      {
        name: permissionsCodes.viewVendors,
        permissionName: "View Vendors Page",
      },
      {
        name: permissionsCodes.addVendors,
        permissionName: "Add/Edit Vendors",
      },
    ],
  },
];

export function permissionGroupsForCompany(groups, companyPermissions) {
  if (!companyPermissions) return groups;

  return groups
    .map((group) => ({
      ...group,
      permissions: group.permissions.filter(
        (permission) =>
          permission.name === "isSuperUser" ||
          companyPermissions[permission.name] === true,
      ),
    }))
    .filter((group) => group.permissions.length > 0);
}

export const superUserPermissionsList = [
  {
    category: "Super User",
    PermissionCategoryID: 0,
    permissions: [
      {
        name: "isSuperUser",
        permissionName: "Has Super User Capabilities",
      },
    ],
  },
  ...permissionsList,
];

const formFlags = [
  permissionsCodes.viewForms,
  permissionsCodes.addForms,
  permissionsCodes.submitForms,
];

export const permissionAreas = [
  {
    id: "company",
    label: "Company profile",
    options: [
      {
        name: permissionsCodes.viewCompanyProfile,
        label: "View company profile",
      },
      {
        name: permissionsCodes.editCompanyData,
        label: "Edit company data",
        requires: permissionsCodes.viewCompanyProfile,
      },
    ],
  },
  {
    id: "users",
    label: "Users",
    packageGroups: [
      {
        id: "addRemove",
        label: "Add and remove",
        names: [permissionsCodes.addRemoveUsers],
      },
    ],
    options: [
      { name: permissionsCodes.viewUsersPage, label: "View users" },
      {
        name: permissionsCodes.addEditUsers,
        label: "Edit users",
        requires: permissionsCodes.viewUsersPage,
      },
      {
        name: permissionsCodes.addRemoveUsers,
        label: "Add and remove users",
        requires: permissionsCodes.viewUsersPage,
      },
      {
        name: permissionsCodes.impersonate,
        label: "Impersonate users",
        requires: permissionsCodes.viewUsersPage,
      },
      {
        name: permissionsCodes.manageUserGroups,
        label: "Manage user groups",
        requires: permissionsCodes.viewUsersPage,
      },
    ],
  },
  {
    id: "positions",
    label: "Positions",
    options: [
      { name: permissionsCodes.viewPositionsPage, label: "View positions" },
      {
        name: permissionsCodes.addEditPositions,
        label: "Add and edit positions",
        requires: permissionsCodes.viewPositionsPage,
      },
    ],
  },
  {
    id: "locations",
    label: "Locations",
    packageGroups: [
      {
        id: "addRemove",
        label: "Add and remove",
        names: [permissionsCodes.addRemoveLocations],
      },
    ],
    options: [
      { name: permissionsCodes.viewLocations, label: "View locations" },
      {
        name: permissionsCodes.addEditLocations,
        label: "Edit locations",
        requires: permissionsCodes.viewLocations,
      },
      {
        name: permissionsCodes.addRemoveLocations,
        label: "Add and remove locations",
        requires: permissionsCodes.viewLocations,
      },
      {
        name: permissionsCodes.locationGroups,
        label: "Manage location groups",
        requires: permissionsCodes.viewLocations,
      },
    ],
  },
  {
    id: "gl",
    label: "GL accounts",
    options: [
      { name: permissionsCodes.viewGLAccounts, label: "View GL accounts" },
      {
        name: permissionsCodes.addEditGLAccounts,
        label: "Add and edit GL accounts",
        requires: permissionsCodes.viewGLAccounts,
      },
      {
        name: permissionsCodes.glAccountGroups,
        label: "Manage GL account groups",
        requires: permissionsCodes.viewGLAccounts,
      },
    ],
  },
  {
    id: "reporting",
    label: "Reporting",
    packageGroups: [
      { id: "forms", label: "Forms", names: formFlags },
      {
        id: "incidents",
        label: "Incidents",
        names: [permissionsCodes.viewSubmittedReports],
      },
      {
        id: "audits",
        label: "Audits",
        names: [permissionsCodes.viewAuditPage],
      },
      {
        id: "it",
        label: "IT tickets",
        names: [permissionsCodes.viewITPage],
      },
      {
        id: "maintenance",
        label: "Maintenance",
        names: [permissionsCodes.viewMaintenancePage],
      },
      {
        id: "surveys",
        label: "Surveys",
        names: [permissionsCodes.viewSurveys],
      },
      {
        id: "other",
        label: "Other",
        names: [permissionsCodes.viewOthers],
      },
    ],
    options: [
      {
        name: permissionsCodes.viewForms,
        label: "View and schedule forms",
      },
      {
        name: permissionsCodes.addForms,
        label: "Add forms",
        requires: permissionsCodes.viewForms,
      },
      {
        name: permissionsCodes.submitForms,
        label: "Submit forms",
        requires: permissionsCodes.viewForms,
      },
      {
        name: permissionsCodes.viewSubmittedReports,
        label: "Incident reports",
      },
      { name: permissionsCodes.viewAuditPage, label: "Audit reports" },
      { name: permissionsCodes.viewITPage, label: "IT tickets" },
      { name: permissionsCodes.viewMaintenancePage, label: "Maintenance" },
      { name: permissionsCodes.viewSurveys, label: "Surveys" },
      { name: permissionsCodes.viewOthers, label: "Other reports" },
    ],
  },
  {
    id: "assets",
    label: "Assets",
    options: [
      { name: permissionsCodes.viewAssets, label: "View assets" },
      {
        name: permissionsCodes.addAssets,
        label: "Add and edit assets",
        requires: permissionsCodes.viewAssets,
      },
      {
        name: permissionsCodes.viewAllAssets,
        label: "View all assets",
        requires: permissionsCodes.viewAssets,
      },
    ],
  },
  {
    id: "vendors",
    label: "Vendors",
    options: [
      { name: permissionsCodes.viewVendors, label: "View vendors" },
      {
        name: permissionsCodes.addVendors,
        label: "Add and edit vendors",
        requires: permissionsCodes.viewVendors,
      },
    ],
  },
];

export function areaFlagNames(area) {
  const names = [];
  (area.options || []).forEach((option) => {
    if (!names.includes(option.name)) names.push(option.name);
  });
  (area.packageGroups || []).forEach((group) => {
    group.names.forEach((name) => {
      if (!names.includes(name)) names.push(name);
    });
  });
  return names;
}

export function optionAllowed(companyPermissions, name) {
  if (!companyPermissions) return true;
  return companyPermissions[name] === true;
}

export function areaIncluded(companyPermissions, area) {
  if (!companyPermissions) return true;
  return areaFlagNames(area).some((name) => companyPermissions[name] === true);
}

export function areaIsOn(permissions, area) {
  return areaFlagNames(area).some((name) => permissions?.[name] === true);
}

export function namesAreOn(permissions, names) {
  return names.some((name) => permissions?.[name] === true);
}

export function applyPackageNames(permissions, names, turnOn) {
  const next = { ...(permissions || {}) };
  names.forEach((name) => {
    next[name] = turnOn;
  });
  return next;
}

export function applyGrantToggle(
  permissions,
  area,
  optionName,
  companyPermissions,
) {
  const current = { ...(permissions || {}) };
  const option = area.options.find((item) => item.name === optionName);
  if (!option) return current;

  const turningOn = current[optionName] !== true;
  const next = { ...current, [optionName]: turningOn };

  if (
    turningOn &&
    option.requires &&
    optionAllowed(companyPermissions, option.requires)
  ) {
    next[option.requires] = true;
  }

  if (!turningOn) {
    area.options.forEach((item) => {
      if (item.requires === optionName) next[item.name] = false;
    });
  }

  return next;
}
